import { useEffect, useRef } from 'react'
import Hls from 'hls.js'

interface HlsVideoPlayerProps {
  src: string
  poster?: string
  autoPlay?: boolean
}

export function HlsVideoPlayer({ src, poster, autoPlay = true }: HlsVideoPlayerProps) {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const el = videoRef.current
    if (!el) return
    let hls: Hls | null = null
    if (Hls.isSupported()) {
      hls = new Hls()
      hls.loadSource(src)
      hls.attachMedia(el)
    } else if (el.canPlayType('application/vnd.apple.mpegurl')) {
      el.src = src
    }
    if (autoPlay) {
      void el.play().catch(() => {})
    }
    return () => {
      hls?.destroy()
    }
  }, [src, autoPlay])

  return (
    <video
      ref={videoRef}
      poster={poster}
      controls
      autoPlay={autoPlay}
      playsInline
      className="w-full h-full bg-black"
    />
  )
}
